<template>
    <li class="relative">
        <component
            :is="option.attributes.image || name === 'finish' ? ProductBuilderOptionSwatch : ProductBuilderOptionRadio"
            :option="option"
            :name="name"
            :disabled="isDisabled"
            @preview="showDetails = true"
            @change="handleSelect"
            :checked="isSelected"
        />
        <Teleport to="#dialogs">
            <Transition name="slide-fade-bottom">
                <div v-if="showDetails" class="fixed overflow-auto inset-0 z-50 w-full h-full bg-gray-775 flex items-start justify-center text-white">
                    <div class="fixed top-0 right-0 p-4">
                        <button
                            type="button"
                            @click="showDetails = false"
                            class="btn-app-icon-black-on-gray"
                        >
                            <span class="sr-only">Close Product Builder</span>
                            <BaseSvg name="Close" aria-hidden="true" />
                        </button>
                    </div>
                    <div class="p-6 pt-20 text-center space-y-4">
                        <h2 class="font-semibold text-2xl">{{ option.attributes.label}}</h2>
                        <div v-if="option.attributes.description" class="text-white max-w-prose mx-auto">
                            {{ option.attributes.description }}
                        </div>
                        <div
                            v-if="option.attributes.image && assetUrl(option.attributes.image, 'product-detail')"
                            class="max-w-4xl"
                        >
                            <img :src="assetUrl(option.attributes.image, 'product-detail')" loading="lazy" />
                        </div>
                    </div>
                </div>
            </Transition>
        </Teleport>
    </li>
</template>
<script setup>
import { BaseSvg, ProductBuilderOptionRadio, ProductBuilderOptionSwatch } from "@/Components";
import { useAssetTransforms, useProductBuilder } from "@/Composables";
import { computed, ref } from "vue";

const { assetUrl } = useAssetTransforms();
const { optionIsInvalid } = useProductBuilder()

const emit = defineEmits(["select"]);
const showDetails = ref(false)

const props = defineProps({
    name: {
        type: String,
        required: true,
    },
    option: {
        type: Object,
        required: true,
    },
    value: {
        type: String,
    },
    sku: {
        type: String,
        required: true,
    },
    validate: {
        type: Boolean,
        default: true,
    }
})

const isDisabled = computed(() => props.validate && optionIsInvalid(props.sku, props.option))
const isSelected = computed(() => props.value === props.option.attributes.value)

function handleSelect() {
    emit('select', props.option)
}
</script>
